import React from 'react';

import styles from './styles';
import view from '../../Enums';
import { isEmptyObject, isEmptyString, path } from '../../utils';
import { withResizer, withTranslations } from '../../HoCs';
import Component from '../../ui-components/Component';
import Header from '../../ui-components/Header/Simple';
import SideBar from './components/SideBar';
import MainBody from './components/MainBody';
import IframeLandingPage from '../LandingPageNew/IframeLandingPage';
import { getCtaLinkWithUtmParams } from '../../utils/campaignUtils';

class TnC extends Component {

    styles = styles;
    mainbodyRef = React.createRef();

    state = {
        data: path(this.props.translationsData, 'custom_translations', {}),
        tnc_iframe_link: this.guc('tnc_iframe_link'),
    };

    getViewMode = () => this.getWidth() >= 1024 ? view.DESKTOP : this.getWidth() >= 840 ? view.TAB : view.MOBILE;

    getContentAtIndex = (s_i, c_i) => this.state.data.section_details[s_i].contents_points[c_i];

    isValidContentHeading = (s_i, c_i) => this.getContentAtIndex(s_i, c_i).type_content === 'HTML' && (
        c_i == 0 || this.getContentAtIndex(s_i, c_i).content_heading != this.getContentAtIndex(s_i, c_i - 1).content_heading
    ) && !isEmptyString(this.getContentAtIndex(s_i, c_i).content_heading);

    onSidebarContentClicked = (s_i, c_i) => this.mainbodyRef.current.scrollTo(s_i, c_i);

    render = () => {
        const { data, tnc_iframe_link } = this.state;

        if (isEmptyObject(data) && !tnc_iframe_link) return; // also go to home
        return tnc_iframe_link  ? <IframeLandingPage link={getCtaLinkWithUtmParams(tnc_iframe_link)}/> :
            <div style={this.gs('container')}>
            <Header style={this.gs('header')} />
            <div style={this.gs('body')}>
                <SideBar data={data} viewMode={this.getViewMode()} isValidContentHeading={this.isValidContentHeading} onContentClicked={this.onSidebarContentClicked} />
                <MainBody data={data} viewMode={this.getViewMode()} isValidContentHeading={this.isValidContentHeading} ref={this.mainbodyRef} />
            </div>
        </div>;
    }

}

export default withTranslations(withResizer(TnC));
